import Box from "./Box"
import List from "./List"
import ListItem from "./ListItem"
import Link from "./Link"
import LinkText from "./LinkText"

export default {
  Box,
  List,
  ListItem,
  Link,
  LinkText
}
